var toS = require('./toS')

/**
 * @param  {*} x value
 * @return {boolean} isDate
 *
 * @since 3.0.0
 * @memberOf is
 * @func isDate
 *
 * @example
 *
 *  isDate(new Date())
 *  //=> true
 *  isDate(Date.now())
 *  //=> false
 *  isDate(1)
 *  //=> false
 *  isDate('')
 *  //=> false
 *
 * @example
 *
 *  const e = {}
 *  eh[Symbol.toStringTag] = '[Object Date]'
 *  isDate(eh)
 *  //=> true
 *
 * @example
 *
 *  class Eh extends Date()
 *  isDate(new Eh())
 *  //=> true
 */
module.exports = function (x) { return x instanceof Date || toS(x) === '[object Date]'; }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZS5qcyIsInNvdXJjZXMiOlsiZGF0ZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCB0b1MgPSByZXF1aXJlKCcuL3RvUycpXG5cbi8qKlxuICogQHBhcmFtICB7Kn0geCB2YWx1ZVxuICogQHJldHVybiB7Ym9vbGVhbn0gaXNEYXRlXG4gKlxuICogQHNpbmNlIDMuMC4wXG4gKiBAbWVtYmVyT2YgaXNcbiAqIEBmdW5jIGlzRGF0ZVxuICpcbiAqIEBleGFtcGxlXG4gKlxuICogIGlzRGF0ZShuZXcgRGF0ZSgpKVxuICogIC8vPT4gdHJ1ZVxuICogIGlzRGF0ZShEYXRlLm5vdygpKVxuICogIC8vPT4gZmFsc2VcbiAqICBpc0RhdGUoMSlcbiAqICAvLz0+IGZhbHNlXG4gKiAgaXNEYXRlKCcnKVxuICogIC8vPT4gZmFsc2VcbiAqXG4gKiBAZXhhbXBsZVxuICpcbiAqICBjb25zdCBlID0ge31cbiAqICBlaFtTeW1ib2wudG9TdHJpbmdUYWddID0gJ1tPYmplY3QgRGF0ZV0nXG4gKiAgaXNEYXRlKGVoKVxuICogIC8vPT4gdHJ1ZVxuICpcbiAqIEBleGFtcGxlXG4gKlxuICogIGNsYXNzIEVoIGV4dGVuZHMgRGF0ZSgpXG4gKiAgaXNEYXRlKG5ldyBFaCgpKVxuICogIC8vPT4gdHJ1ZVxuICovXG5tb2R1bGUuZXhwb3J0cyA9IHggPT4geCBpbnN0YW5jZW9mIERhdGUgfHwgdG9TKHgpID09PSAnW29iamVjdCBEYXRlXSdcbiJdLCJuYW1lcyI6WyJjb25zdCJdLCJtYXBwaW5ncyI6IkFBQUFBLEdBQUssQ0FBQyxHQUFHLEdBQUcsT0FBTyxDQUFDLE9BQU8sQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQWtDNUIsTUFBTSxDQUFDLE9BQU8sR0FBRyxVQUFBLENBQUMsQ0FBQSxDQUFDLEFBQUcsU0FBQSxDQUFDLFlBQVksSUFBSSxJQUFJLEdBQUcsQ0FBQyxDQUFDLENBQUMsS0FBSyxlQUFlLEdBQUE7In0=